import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

import Step1 from "../components/NewList/Step1";
import Step2 from "../components/NewList/Step2";
import ModelsModal from "../components/NewPedigree/ModelsModal";
import MainStructure from "../components/containers/MainStructure";
import Loader from "../assets/images/loader-2.gif";
import useSourAlert from "../hooks/useSourAlert";
import SourAlert from "../components/elements/SourAlert";

import { horseListService } from "../api";

const EditList = () => {
	const { id } = useParams();
	const navigate = useNavigate();
	const [loading, setLoading] = useState(true);
	const [isOpenModels, setIsOpenModels] = useState(false);

	const [pedigreeData, setPedigreeData] = useState({
		name: "",
		type: "sire",
		horses: [],
	});

	const [initialSelectedHorses, setInitialSelectedHorses] = useState([]);

	const [alertProps, showAlert] = useSourAlert();

	useEffect(() => {
		if (!id) return;
		setLoading(true);

		Promise.all([horseListService.list(), horseListService.listHorses(id)])
			.then(([listsData, horsesData]) => {
				const found = listsData.results.find(
					(item) => item.id === parseInt(id, 10)
				);
				if (!found) {
					showAlert({
						type: "error",
						title: "List not found",
						description: `No list exists with id ${id}`,
						okButtonText: "Ok",
					});
					return;
				}

				setPedigreeData({
					name: found.name,
					type: found.type,
					horses: horsesData.results.map((h) => h.id),
				});

				setInitialSelectedHorses(
					horsesData.results.map((h) => ({
						value: h.id,
						label: h.name,
					}))
				);
			})
			.catch((err) => {
				console.error(err);
				showAlert({
					type: "error",
					title: "Error uploading list",
					description: "There was a problem obtaining the information.",
					okButtonText: "Ok",
				});
			})
			.finally(() => setLoading(false));
	}, [id]);

	const handleSave = () => {
		const payload = {
			name: pedigreeData.name,
			type: pedigreeData.type,
			horses: pedigreeData.horses,
		};
		if (pedigreeData.file) {
			payload.file = pedigreeData.file;
		}

		horseListService
			.update(id, payload)
			.then(() => {
				navigate("/my-lists");
			})
			.catch((err) => {
				console.error(err);
				let description =
					"An error occurred while generating the report. Please try again.";

				if (err && typeof err === "object") {
					const messages = Object.values(err)
						.flat()
						.filter((m) => typeof m === "string");
					if (messages.length > 0) {
						description = messages.join(" ");
					}
				}
				showAlert({
					type: "error",
					title: "Error",
					description,
					okButtonText: "Ok",
				});
			});
	};

	if (loading)
		return (
			<div className="redirect">
				<img src={Loader} alt="Loading..." className="loader" />
			</div>
		);
	return (
		<MainStructure>
			<div className="center">
				<h2 className="huge-letters is-black">
					Edit <span className="is-bold">List</span>
				</h2>
				<br />

				<div className="step1-container">
					<Step1
						selected={pedigreeData}
						handleStep1Change={(newData) =>
							setPedigreeData((prev) => ({ ...prev, ...newData }))
						}
						setIsOpenModels={setIsOpenModels}
					/>
				</div>

				<br />

				<div className="step2-container mb-40">
					<Step2
						handleReportClick={handleSave}
						setPedigreeData={setPedigreeData}
						pedigreeData={pedigreeData}
						initialSelectedHorses={initialSelectedHorses}
					/>
				</div>
			</div>

			<ModelsModal
				isOpenModels={isOpenModels}
				setIsOpenModels={setIsOpenModels}
			/>

			<SourAlert {...alertProps} />
		</MainStructure>
	);
};

export default EditList;
